import { Flex, Switch, SwitchProps } from 'antd'
import React from 'react'

type Props = SwitchProps

export const SwitchWrapped: React.FC<Props> = ({ id, ...props }) => {
  return (
    <Flex id={id}>
      <Switch {...props} />
    </Flex>
  )
}
